<template>
  <div class="content-box">
    <StepBasedForm
        :title="coupon.id ?  $t('COUPON.EDIT_FORM.HEADER.TITLE') : $t('COUPON.ADD_FORM.HEADER.TITLE')"
        :range_label="step_label"
        :current_step="step"
        :max_steps="max_steps"
        @onClose="clearCouponState"
    >
        <CouponType
            v-if="step === 1"
            :coupon="coupon"
            :kinds="kinds"
            :status_list="status_list"
            @onNext="onNext"
        />
        <CouponDiscount
            v-if="step === 2"
            :coupon="coupon"
            :discount_types="discount_types"
            :redeemed_list="redeemed_list"
            @onBack="onBack"
            @onNext="onNext"
        />
        <AddCouponPreview
            v-if="showPreview"
            :isOpen="showPreview"
            :onClose="onClosePreview"
            :coupon="coupon"
            :kinds="kinds"
            :discount_types="discount_types"
            :redeemed_list="redeemed_list"
            @onCreate="clearCouponState"
            @onEdit="clearCouponState"
        />
    </StepBasedForm>
  </div>
</template>

<script>
import StepBasedForm from "dashboard/components/widgets/forms/StepBasedForm.vue"
import AddCouponPreview from "./addSteps/AddCouponPreview.vue"
import CouponDiscount from "./addSteps/CouponDiscount.vue"
import CouponType from "./addSteps/CouponType.vue"
import {COUPON_REDEEM_LIST,COUPON_KINDS,COUPON_STATUS} from "./constant.coupon"
import CouponAPI from "../../../../api/coupons"

export default {
    components:{
        StepBasedForm,
        CouponType,
        CouponDiscount,
        AddCouponPreview,
    },
    props:{
        editable_coupon:{
            type: [Object,undefined,null]
        },
    },
    data(){
        // const productSelectedOption = this.$t('COUPON.ADD_FORM.TYPE_FORM.PRODUCT.LIST.ALL');

        return {
            step: 1,
            max_steps: 2,
            showPreview: false,

            // form states
            coupon:{
                kind_index: 0,
                name: "",
                code: "",
                products: [],
                selected_product_option: {id:'all',title: ''},
                image_file: null,
                discount_type_index: 0,
                discount_value: 0,
                redeemed_type: null,
                // duration_list: [
                //   {id:1,title:"A"},
                //   {id:2,title:"B"},
                //   {id:3,title:"C"},
                // ],
                date_range_limit: false,
                redemp_date: null,
                redemp_time: null,
                is_redemp_limit: false,
                redeemed_limit: 0,
                limit_per_month: 0,
                templates: {
                    title: "",
                    footer: "",
                    // image: ""
                },
                img_file:{
                    new_upload: null,
                    preview_url: null,
                },
            },
        }
    },
    created(){
        this.coupon.selected_product_option = {
            id:'all',
            title: this.$t('COUPON.ADD_FORM.TYPE_FORM.PRODUCT.LIST.ALL')
        }
    },
    computed:{
        step_label(){
            return ` ${this.step} ${this.$t('COUPON.ADD_FORM.HEADER.STEP_OF')} ${this.max_steps} ${this.$t('COUPON.ADD_FORM.HEADER.STEP_REMAINING')}`
        },
        kinds(){
            return COUPON_KINDS.map(el=>({...el,
                label:this.$t(el.label),
                description:this.$t(el.description),
                disable: !!this.editable_coupon?.id,

            }))
        },
        discount_types(){
            return [
                {
                    id:'percentage',
                    label: this.$t('COUPON.ADD_FORM.TYPE_FORM.DISCOUNT_TYPE.LIST.PERCENT'),
                },
                {
                    id:'fixed',
                    label: this.$t('COUPON.ADD_FORM.TYPE_FORM.DISCOUNT_TYPE.LIST.FIXED'),
                },
            ]
        },
        redeemed_list(){
            return COUPON_REDEEM_LIST.map(el=>({
                ...el,
                title: this.$t(el.title),
            }))
        },
        status_list(){
            return COUPON_STATUS;
        },
    },
    mounted(){
        this.populateEditCoupon();
    },
    methods:{
        async clearCouponState(){
            this.onClosePreview();
            this.step = 1;
            this.$emit('onClose');
        },
        async populateEditCoupon(){
            try {
                console.log(this.editable_coupon,"EDD");
                if (this.editable_coupon?.id) {
                    const data = this.editable_coupon;
                    const kind_index = COUPON_KINDS.findIndex(el=>el.id === data.kind.toLowerCase());
                    const status = this.status_list.find(el=>el.id === data.status);
                    const discount_type_index = this.discount_types.findIndex(el=>el.id === data.discount_type);
                    const redeemed_type = this.redeemed_list.find(el=>el.id === data.redeemed_type);
                    const date_range_limit  = !!data.expired_at;
                    let redemp_date = '';
                    let redemp_time = '';
                    console.log({discount_type_index});
                    if (data.expired_at) {
                        redemp_date = new Date(data.expired_at?.slice(0,-1));
                        redemp_time = new Date(data.expired_at?.slice(0,-1));
                    }


                    this.coupon = {
                        ...data,
                        // id: data.id,
                        kind_index,
                        status,
                        // name: data.name,
                        // code: data.code,
                        products: data.products.map(el=>({id:parseInt(el)})),
                        discount_type_index,
                        // discount_value: data.discount_value,
                        redeemed_type,
                        date_range_limit,  // true/false
                        redemp_date,
                        redemp_time,
                        is_redemp_limit: !!data.redeemed_limit,
                        // redeemed_limit: data.redeemed_limit,
                        limit_per_month: data.extras?.limit_per_month,
                        // templates: data.templates,
                        img_file:{
                            new_upload: null,
                            preview_url: data.image64,
                        },
                    };
                    if (this.coupon.products.length) {
                        this.coupon.selected_product_option = {
                            id:'custom',
                            title: this.$t('COUPON.ADD_FORM.TYPE_FORM.PRODUCT.LIST.CUSTOM')
                        }
                    }
                }
                console.log(this.coupon,"After populate");
                // const query = this.$route.query;
                // console.log(query);
                // if (query?.coupon_id && query.mode === 'edit') {


                //     const {data} = await CouponAPI.getCouponById(query.coupon_id);
                //     console.log(data);
                //     const kind_index = this.kinds.findIndex(el=>el.id === data.kind);
                //     const discount_type_index = this.discount_types.findIndex(el=>el.id === data.discount_type);
                //     const redeemed_type = this.redeemed_list.find(el=>el.id === data.redeemed_type);
                //     const date_range_limit  = !!data.expired_at;
                //     const redemp_date = data.expired_at?.split('T')[0];
                //     const redemp_time = data.expired_at?.split('T')[1];
                //     console.log({discount_type_index});

                //     this.coupon = {
                //         kind_index,
                //         name: data.name,
                //         code: data.code,
                //         products: data.products.map(el=>({id:el})),
                //         discount_type_index,
                //         discount_value: data.discount_value,
                //         redeemed_type,
                //         date_range_limit,  // true/false
                //         redemp_date,
                //         redemp_time,
                //         is_redemp_limit: !!data.redeemed_limit,
                //         redeemed_limit: data.redeemed_limit,
                //         limit_per_month: data.extras?.limit_per_month,
                //         templates: data.templates,
                //     };
                // }
            } catch (error) {
                console.log(error);

            }
        },
        onNext(step){
            if (step === 3) {
                this.showPreview = true;
                return
            }
            this.step = step;
        },
        onBack(step){
            this.step = step;
        },
        onClosePreview(){
            this.showPreview = false;
        },
        // onClosePage(){
        //     // this.$router.push({name:"coupons_list"})
        //     this.clearCouponState();
        //     this.$emit('onClose');
        // },
    },
}
</script>

<style>

</style>